<mdk-modal id="{{ identifier }}" title="Nieuwe prikcampagne" [closable]="false">
  <ng-container button>
    <button
      #createSurveyCampaignOpenButton
      class="mdk-modal__hidden-toggle-button"
      [attr.data-vl-modal-open]="identifier"
      title="Modal voor campagne-aanmaken openen"
    ></button>
  </ng-container>
  <ng-container body>
    <div
      class="vl-modal-dialog__content"
      id="modal-{{ identifier }}-description"
    >
      <form class="vl-form">
        <div class="vl-form__group">
          <div class="vl-form-grid vl-form-grid--is-stacked">
            <div class="vl-form-col--8-12">
              <label
                class="vl-form__label vl-form__label--block"
                for="survey-start-date"
              >
                Datum start campagne
                <span class="vl-annotation">(verplicht)</span><br /><span
                  class="vl-annotation vl-annotation--small"
                  >De eeuw wordt automatisch toegevoegd (00–74 → 20xx, 75–99 →
                  19xx).</span
                ><br><span class="vl-annotation vl-annotation--small">Vul in 6 cijfers in formaat jjmmdd.</span></label
              ><input
                #testStartDate
                type="text"
                pattern="^\d{1,6}$"
                id="survey-start-date"
                name="survey-start-date"
                placeholder="yymmdd"
                required="true"
                [(ngModel)]="createSurveyCampaign.startDate"
                class="vl-input-field vl-input-field--block"
              />
            </div>

            <div class="vl-form-col--8-12">
              <label
                class="vl-form__label vl-form__label--block"
                for="survey-zone"
              >
                Zone
                <span class="vl-annotation">(verplicht)</span></label
              ><select
                name="survey-zone"
                id="survey-zone"
                required="true"
                [(ngModel)]="createSurveyCampaign.zoneCode"
                class="vl-select--block vl-select vl-select--block"
              >
                <option
                  *ngFor="let zone of newSurveyCampaign.surveyZones"
                  value="{{ zone.zoneCode }}"
                >
                  {{ zone.zoneDescription }}
                </option>
              </select>
            </div>

            <div class="vl-form-col--8-12" *ngIf="newSurveyCampaign?.tideStations?.length ?? 0 > 0">
              <label
                class="vl-form__label vl-form__label--block"
                for="tide-station"
              >
                Getijstation
                <span class="vl-annotation">(verplicht)</span></label
              ><select
                name="tide-station"
                id="tide-station"
                required="true"
                class="vl-select--block vl-select vl-select--block"
                [(ngModel)]="createSurveyCampaign.tideStationCode"
              >
                <option
                  *ngFor="
                    let tideStation of newSurveyCampaign.tideStations
                  "
                  value="{{ tideStation.tideStationCode }}"
                >
                  {{ tideStation.tideStationDescription }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="vl-modal-dialog__footer">
      <div class="vl-action-group">
        <button
          class="vl-button"
          vl-button
          (click)="onClickCreate()"
          title="Bevestig het aanmaken van de campagne"
        >
          <span class="vl-button__label">Aanmaken</span>
        </button>
        <a
          id="close-button"
          class="vl-link"
          data-vl-modal-close
          #createSurveyCampaignCloseButton
        >
          <span
            class="vl-link__icon vl-link__icon--before vl-vi vl-vi-cross"
            aria-hidden="true"
          ></span
          >Annuleer
        </a>
      </div>
    </div>
  </ng-container>
</mdk-modal>
